// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import {
  FAVORITES_LABELS,
  FavoriteLabels,
  lblAddFavoriteToYourList,
  lblDontHaveFavorites,
  lblInspirationRequired,
  lblItemsToFavorite,
} from '../../../labels/Favorites.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';

const favLabels = getLabelFromCopyOrFromTranslation(FAVORITES_LABELS, FavoriteLabels);

const renderText = (headerText, bodyText) => {
  return (
    <Col colSize={{ large: 12, medium: 8, small: 6 }} className="no-favorite-container">
      <BodyCopy
        className="no-favorite-heading"
        fontFamily="secondary"
        fontWeight="extrabold"
        fontSize="fs22"
        aria-hidden="true"
        textAlign="center"
      >
        {headerText}
      </BodyCopy>
      <BodyCopy
        margin="0 0 12px 0"
        className="no-favorite-text"
        fontFamily="secondary"
        fontSize="fs16"
        aria-hidden="true"
        textAlign="center"
      >
        {bodyText}
      </BodyCopy>
    </Col>
  );
};

const NoFavoritesFound = () => {
  return (
    <Row className="no-favorites-found">
      {renderText(
        renderLabel(favLabels[lblDontHaveFavorites], lblDontHaveFavorites),
        renderLabel(favLabels[lblAddFavoriteToYourList], lblAddFavoriteToYourList)
      )}
      {renderText(
        renderLabel(favLabels[lblInspirationRequired], lblInspirationRequired),
        renderLabel(favLabels[lblItemsToFavorite], lblItemsToFavorite)
      )}
    </Row>
  );
};

export default NoFavoritesFound;
